import React from "react";

export const Col = ({ children, md, ...props }) => {
  return (
    <div className={`col-md-${md}`} {...props}>
      {children}
    </div>
  );
};
